module.exports = __webpack_public_path__ + "img/b.454ecb83.png";